import { PaymentStatusEnum } from 'woofwoof-api';
import { translateKey } from 'src/locales/translate';


type VisitStatusInfo = {
  label: string;
  color:
    | 'default'
    | 'primary'
    | 'secondary'
    | 'info'
    | 'success'
    | 'warning'
    | 'error';
  icon?: string;
};

export const mapVisitPaymentStatusToString = (
  status: PaymentStatusEnum | undefined,
): VisitStatusInfo | null => {
  if (!status) {
    return null;
  }

  const statusMap: Record<PaymentStatusEnum, VisitStatusInfo> = {
    created: {
      label: translateKey("hardcoded.oczekiwanie_na_platnosc"),
      color: 'warning',
      icon: 'solar:hourglass-bold-duotone',
    },
    verified: {
      label: translateKey("hardcoded.platnosc_potwierdzona"),
      color: 'success',
      icon: 'solar:check-circle-bold',
    },
    failed: {
      label: translateKey("hardcoded.platnosc_nieudana"),
      color: 'error',
      icon: 'solar:close-circle-bold',
    },
    refunded: {
      label: translateKey("hardcoded.platnosc_zwrocona"),
      color: 'info',
      icon: 'solar:round-transfer-horizontal-bold',
    },
  };

  return statusMap[status] || null;
};
